import {Over} from '@dnd-kit/core';

import {isNil} from 'ramda';

import {getSortableContainerId, parseDndItemId} from '@dms/features/dnd';

import {parseSortableDndItemId} from './parseSortableDndItemId';

/**
 * The container a drop lands in: the sortable container of the tile under the pointer, or the
 * container itself when the pointer is over its free area (a droppable id wraps the container id).
 */
export const getDndOverContainerId = (over: Over) =>
  isNil(parseSortableDndItemId(over.id))
    ? parseDndItemId(over.id).id
    : getSortableContainerId(over);
